export default __webpack_public_path__ + "/assets/bg-superabile-03.jpg";